<div class="asset-card col-12" [ngClass]="devicesCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">

    <div class="asset-card-header row" [ngClass]="{ 'disabled-header': (equipmentInstances | keyvalue).length === 0 }">
        <h2 class="card-title asset-card-title col-10">
            {{'COMMON.EQUIPMENT' | translate}}
        </h2>
        <div *ngIf="(equipmentInstances | keyvalue).length > 0" class="collapse-arrow col-2">
            <button
                class="action-button"
                (click)="devicesCardExpanded = true"
                *ngIf="!devicesCardExpanded"
            >
                <svg
                *ngIf="!devicesCardExpanded"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M1 1L5 5L9 1"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                </svg>
            </button>
            <button
                class="action-button"
                (click)="devicesCardExpanded = false"
                *ngIf="devicesCardExpanded"
            >
                <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M9 5L5 1L1 5"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                </svg>
            </button>
        </div>
    </div>

    <div
        *ngIf="devicesCardExpanded && (equipmentInstances | keyvalue).length > 0"
        class="asset-card-content"
        @slideToggle
    >
        <div *ngFor="let group of equipmentInstances | keyvalue">

            <div class="device-header">
                <div class="device-type">
                    {{ formatKey(group.key)}}
                </div>

                <div class="device-type-count">
                    {{ group.value.length }}
                </div>

                <div *ngIf="hasAttributeValues(group.value[currentIndexes[group.key]])" class="device-list-scrolling">
                    <button (click)="prev(group.key)" [disabled]="currentIndexes[group.key] === 0" class="action-button">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.83366 7.15667H12.1462C12.3823 7.15667 12.5802 7.07681 12.7399 6.91708C12.8996 6.75736 12.9795 6.55944 12.9795 6.32333C12.9795 6.08722 12.8996 5.88931 12.7399 5.72958C12.5802 5.56986 12.3823 5.49 12.1462 5.49H2.83366L6.91699 1.40667C7.08366 1.24 7.16352 1.04556 7.15658 0.823333C7.14963 0.601111 7.06283 0.406667 6.89616 0.24C6.72949 0.0872222 6.53505 0.00736111 6.31283 0.000416667C6.0906 -0.00652778 5.89616 0.0733333 5.72949 0.24L0.229492 5.74C0.146159 5.82333 0.0871315 5.91361 0.0524092 6.01083C0.0176868 6.10806 0.000326157 6.21222 0.000326157 6.32333C0.000326157 6.43444 0.0176868 6.53861 0.0524092 6.63583C0.0871315 6.73306 0.146159 6.82333 0.229492 6.90667L5.72949 12.4067C5.88227 12.5594 6.07324 12.6358 6.30241 12.6358C6.53158 12.6358 6.72949 12.5594 6.89616 12.4067C7.06283 12.24 7.14616 12.0421 7.14616 11.8129C7.14616 11.5838 7.06283 11.3858 6.89616 11.2192L2.83366 7.15667Z" fill="#F36943"/>
                        </svg>
                    </button>
                    <div class="num-of-count">
                        {{ currentIndexes[group.key] + 1 }} of {{ group.value.length }}
                    </div>
                    <button (click)="next(group.key, group.value)" [disabled]="currentIndexes[group.key] === group.value.length - 1" class="action-button">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.1458 7.15667H0.833333C0.597222 7.15667 0.399306 7.07681 0.239583 6.91708C0.0798611 6.75736 0 6.55944 0 6.32333C0 6.08722 0.0798611 5.88931 0.239583 5.72958C0.399306 5.56986 0.597222 5.49 0.833333 5.49H10.1458L6.0625 1.40667C5.89583 1.24 5.81597 1.04556 5.82292 0.823333C5.82986 0.601111 5.91667 0.406667 6.08333 0.24C6.25 0.0872222 6.44444 0.00736111 6.66667 0.000416667C6.88889 -0.00652778 7.08333 0.0733333 7.25 0.24L12.75 5.74C12.8333 5.82333 12.8924 5.91361 12.9271 6.01083C12.9618 6.10806 12.9792 6.21222 12.9792 6.32333C12.9792 6.43444 12.9618 6.53861 12.9271 6.63583C12.8924 6.73306 12.8333 6.82333 12.75 6.90667L7.25 12.4067C7.09722 12.5594 6.90625 12.6358 6.67708 12.6358C6.44792 12.6358 6.25 12.5594 6.08333 12.4067C5.91667 12.24 5.83333 12.0421 5.83333 11.8129C5.83333 11.5838 5.91667 11.3858 6.08333 11.2192L10.1458 7.15667Z" fill="#F36943"/>
                        </svg>
                    </button>
                </div>
            </div>

            <ng-container *ngIf="group.value[currentIndexes[group.key]] as currentItem">
                <div class="asset-card-content devices-card-content">
                    <div class="asset-card-info row">
                        <lib-static-dropdown-edit-row
                            *ngIf="editEnabled && isAssetRatingEditable && group.key === 'PowerTransformer'; else assetRatingView"
                            [label]="'COMMON.ASSET_RATING.RATING' | translate"
                            [options]="assetRatingOptions"
                            [originalValue]="currentItem.assetRatingId"
                            [(value)]="editedAssetRatings[currentItem.mrId]"
                        >
                        </lib-static-dropdown-edit-row>
                        <ng-template #assetRatingView>
                            <div class="d-flex align-items-center">
                                <div class="col-5 asset-card-content-title">{{ 'COMMON.ASSET_RATING.RATING' | translate }}</div>
                                <div class="col-7 asset-card-content-value">{{ currentItem.assetRating }}</div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <ng-container *ngFor="let section of currentItem.sectionInstances">
                    <!-- <div class="device-header" *ngIf="currentItem.sectionInstances.length > 1">
                        <div class="device-type">{{ section.sectionTitle }}</div>
                    </div> -->
                    <div *ngIf="devicesCardExpanded && section.attributeValues?.length > 0" class="asset-card-content devices-card-content">
                        <div
                        class="asset-card-info row"
                        *ngFor="let attr of section.attributeValues"
                        >
                        <ng-container [ngSwitch]="getRowType(attr)">
                            <lib-attribute-number-edit-row
                            *ngSwitchCase="'number-edit'"
                            [attributeValue]="attr"
                            [editedValues]="getEditedValues(currentItem.mrId)"
                            >
                            </lib-attribute-number-edit-row>

                            <lib-attribute-text-edit-row
                            *ngSwitchCase="'text-edit'"
                            [attributeValue]="attr"
                            [editedValues]="getEditedValues(currentItem.mrId)"
                            >
                            </lib-attribute-text-edit-row>

                            <lib-attribute-date-edit-row
                            *ngSwitchCase="'date-edit'"
                            [attributeValue]="attr"
                            [editedValues]="getEditedValues(currentItem.mrId)"
                            >
                            </lib-attribute-date-edit-row>

                            <lib-attribute-image-edit-row
                            *ngSwitchCase="'image-edit'"
                            [attributeValue]="attr"
                            [editedValues]="getEditedValues(currentItem.mrId)"
                            >
                            </lib-attribute-image-edit-row>

                            <lib-attribute-dropdown-edit-row
                            *ngSwitchCase="'dropdown-edit'"
                            [attributeValue]="attr"
                            [editedValues]="getEditedValues(currentItem.mrId)"
                            >
                            </lib-attribute-dropdown-edit-row>

                            <lib-attribute-selected-options-row
                            *ngSwitchCase="'selected-options'"
                            [attributeValue]="attr"
                            >
                            </lib-attribute-selected-options-row>

                            <lib-attribute-location-row
                            *ngSwitchCase="'location'"
                            [attributeValue]="attr"
                            (mapClicked)="onMapClick($event)"
                            >
                            </lib-attribute-location-row>

                            <lib-attribute-image-row
                            *ngSwitchCase="'image'"
                            [attributeValue]="attr"
                            >
                            </lib-attribute-image-row>

                            <lib-attribute-file-row *ngSwitchCase="'file'" [attributeValue]="attr">
                            </lib-attribute-file-row>

                            <lib-attribute-value-row
                            *ngSwitchCase="'default'"
                            [attributeValue]="attr"
                            >
                            </lib-attribute-value-row>
                        </ng-container>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
